import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AssignmentTaskType } from '../../../../config/api/models/Assignment';
import { Tooltip } from '../Tooltip';
import { Icons, SvgIcon } from '../SvgIcon';
import { Theme, styled } from '@material-ui/core';

const TaskTypeListWrapper = styled('div')<Theme>(({ theme }) => ({
  width: '100%',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  marginTop: theme.spacing(1),
  '& > *': {
    marginRight: theme.spacing(1),
    '&:last-child': {
      marginRight: 0,
    },
  },
}));

type Props = {
  taskTypes: AssignmentTaskType[];
  series?: string[];
};
const TaskTypeList: FC<Props> = ({ taskTypes, series = [] }) => {
  const { t } = useTranslation();

  const seriesTooltip = useMemo(
    () => series || t(`trajectory.sections.exercises.title`),
    [series, t]
  );

  return (
    <TaskTypeListWrapper>
      {taskTypes.includes('framework') && (
        <Tooltip title={t(`trajectory.sections.opbouw.title`)}>
          <SvgIcon icon={Icons.INFO} color="inherit" />
        </Tooltip>
      )}
      {taskTypes.includes('theory') && (
        <Tooltip title={t(`trajectory.sections.theory.title`)}>
          <SvgIcon icon={Icons.THEORY} color="inherit" />
        </Tooltip>
      )}
      {taskTypes.includes('series') && (
        <Tooltip title={seriesTooltip}>
          <SvgIcon icon={Icons.EXERCISES} color="inherit" small />
        </Tooltip>
      )}
    </TaskTypeListWrapper>
  );
};

export default TaskTypeList;
